import React from "react";
import SetupMaster from "./SetupMaster";

/* Shop Transfer Setup — the maintenance screen legacy never had.

   Legacy held this arrangement in MS_FMS_WeeklySalesAmount_TransferConfig with NO page behind
   it: rows were edited straight into SQL Server. Two things read it — the Shop Payments
   settlement and the Shop Summary report — so a row here changes reported money for both shops
   named on it, in every week of the window.

   Saving is deliberately strict: the endpoint refuses a shop transferring to itself, two
   overlapping windows for the same origin, and any chain where a shop would both receive and
   pass on takings. See services/mutation/Setups/ShopTransfer.php. */

const config = {
    entity: "Shop Transfer",
    title: "SHOP TRANSFER",
    addLabel: "Add Shop Transfer",
    pk: "PC_TR_ID",
    labelField: "FROM_SHOP_NAME",
    deleteWarning: "Its weeks will settle at the origin shop again. Setting it Inactive keeps the record of what was agreed.",
    endpoints: {
        list: "services/query/Setups/ShopTransfer.php",
        save: "services/mutation/Setups/ShopTransfer.php",
        del: "services/delete/setup/DeleteShopTransfer.php"
    },
    lookups: [
        // PCGetShops.php is GET-only, unlike the Setups list endpoints.
        { stateKey: "shops", endpoint: "services/query/PCGetShops.php", method: "get", valueField: "PC_SP_ID", labelField: "SP_NAME" },
    ],
    fields: [
        { name: "FROM_SHOP_ID", label: "From Shop (takings move away)", type: "select", lookup: "shops", required: true, md: 6 },
        { name: "TO_SHOP_ID", label: "To Shop (settles them)", type: "select", lookup: "shops", required: true, md: 6 },
        { name: "FROM_WEEK", label: "From Week", type: "week", required: true, md: 4 },
        { name: "TO_WEEK", label: "To Week", type: "week", required: true, md: 4 },
        {
            name: "TR_ACTIVE", label: "Active", type: "select", md: 4, initial: "1",
            options: [{ value: "1", label: "Active" }, { value: "0", label: "Inactive" }]
        },
        { name: "TR_REMARKS", label: "Remarks", type: "text", md: 12 },
    ],
    columns: [
        { label: "FROM SHOP", field: "FROM_SHOP_NAME" },
        { label: "TO SHOP", field: "TO_SHOP_NAME" },
        { label: "FROM WEEK", field: "FROM_WEEK" },
        { label: "TO WEEK", field: "TO_WEEK" },
        { label: "ACTIVE", field: "TR_ACTIVE_TEXT" },
        { label: "REMARKS", field: "TR_REMARKS" },
    ],
    /* NO `approval` BLOCK — Shop Transfer's approve / request workflow was removed on
       2026-10-13 on the user's instruction, alongside Pay Account's. Dropping the config is the
       whole change: SetupMaster guards every part of that surface on `config.approval`
       (rowIsEditable / rowIsOverride return early when it is absent), so the status column, the
       selection checkboxes, the bulk bar and the per-row Approve / Reject / Reopen buttons all
       disappear together. The server-side locks in mutation/Setups/ShopTransfer.php and
       delete/setup/DeleteShopTransfer.php were removed to match.

       TR_STATUS stays on the table, unread. It never gated the money anyway — settlement and
       Shop Summary read pc_shop_transfer without joining it — so no figure changes.

       TR_ACTIVE above is a DIFFERENT thing and still in force: it is the business switch for
       whether an arrangement applies, not a governance flag. */
};

export default function ShopTransferSetup(props) {
    return <SetupMaster config={config} {...props} />;
}
